"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactWindow = require("react-window");

var _SearchOption = _interopRequireDefault(require("./SearchOption"));

var _NoOptionMessage = _interopRequireDefault(require("./NoOptionMessage"));

var MenuList =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(MenuList, _React$Component);

  function MenuList(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, MenuList);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuList).call(this, props));
    _this.state = {
      maxHeight: 260,
      boundedHeightOffset: 0,
      itemHeight: 35
    };
    return _this;
  }

  (0, _createClass2["default"])(MenuList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var elem = this.menuListRef.current;

      if (elem) {
        var bounding = elem.getBoundingClientRect(); // Check if it's out of the viewport on each side

        var outOfBounds = bounding.bottom > window.innerHeight;
        var _this$state = this.state,
            itemHeight = _this$state.itemHeight,
            maxHeight = _this$state.maxHeight,
            boundedHeightOffset = _this$state.boundedHeightOffset;

        if (outOfBounds === true && maxHeight - boundedHeightOffset >= itemHeight) {
          /* eslint-disable-next-line */
          this.setState({
            boundedHeightOffset: boundedHeightOffset + itemHeight
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this; // eslint-disable-next-line react/prop-types


      this.menuListRef = _react["default"].createRef();
      var _this$props = this.props,
          options = _this$props.options,
          children = _this$props.children,
          selectProps = _this$props.selectProps,
          getValue = _this$props.getValue;
      var _this$state2 = this.state,
          itemHeight = _this$state2.itemHeight,
          maxHeight = _this$state2.maxHeight,
          boundedHeightOffset = _this$state2.boundedHeightOffset;

      var _getValue = getValue(),
          _getValue2 = (0, _slicedToArray2["default"])(_getValue, 1),
          value = _getValue2[0];

      var optCount = children.length || 0;
      var initialOffset = options.indexOf(value) * itemHeight;
      var height = Math.min(maxHeight - boundedHeightOffset, itemHeight * Math.max(optCount, 1));

      if (!optCount) {
        return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_SearchOption["default"], {
          selectProps: selectProps,
          availableOptions: children
        }), _react["default"].createElement(_NoOptionMessage["default"], null, selectProps.noOptionsMessage()));
      }

      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_SearchOption["default"], {
        selectProps: selectProps,
        availableOptions: children
      }), _react["default"].createElement(_reactWindow.FixedSizeList, (0, _extends2["default"])({
        height: height,
        itemCount: optCount,
        itemSize: itemHeight,
        initialScrollOffset: initialOffset
      }, this.props), function (_ref) {
        var index = _ref.index,
            style = _ref.style; // Improves performance in react-select's row highlighting code
        // highlighting changed to be CSS driven

        delete children[index].props.innerProps.onMouseMove;
        delete children[index].props.innerProps.onMouseOver;
        return _react["default"].createElement("div", {
          ref: _this2.menuListRef,
          style: style
        }, children[index]);
      }));
    }
  }]);
  return MenuList;
}(_react["default"].Component);

var _default = MenuList;
exports["default"] = _default;